import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";

export default function Blog() {
  const { t, lang, pickL } = useI18n();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog-feed").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <Seo title="Blog" />
      <PageHero eyebrow="Blog" title={lang === "de" ? "Einblicke & Wissen" : "Insights & Knowledge"}
        subtitle={lang === "de" ? "Artikel über Web, Mobile, Software und Technologie." : "Articles on web, mobile, software and technology."} />
      <section className="container-x py-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.05}>
            <Link to={`/blog/${p.slug}`} className="group surface overflow-hidden block h-full" data-testid={`blog-${p.slug}`}>
              <div className="aspect-[16/9] overflow-hidden"><img src={p.cover_image} alt="" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
              <div className="p-6">
                <span className="text-xs uppercase tracking-wide text-primary font-semibold">{p.category}</span>
                <h3 className="font-display font-bold text-lg mt-1">{pickL(p, "title")}</h3>
                <p className="text-sm text-muted-foreground mt-2">{pickL(p, "excerpt")}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">{t("common.learnMore")} <ArrowRight size={14} /></span>
              </div>
            </Link>
          </Reveal>
        ))}
        {posts.length === 0 && <p className="text-muted-foreground">{t("common.none")}</p>}
      </section>
    </div>
  );
}
